module.exports = __webpack_public_path__ + "static/media/ms-tutoring.f826a4d9.jpg";